import { observer } from 'mobx-react'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  ModalContent,
  ModalTitle,
  ModalFooter,
  Button,
} from 'suomifi-ui-components'
import LocalizedString, {
  LocalizedParagraphs,
} from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'
import { useSubmitDeclineAetTodistuspyynto } from 'todistukset-ui/src/vtj/stores/actions/aet-signer-form-actions'
import { DialogItem } from 'todistukset-ui/src/vtj/stores/dialogs.mobx.store'
import { useStore } from 'todistukset-ui/src/vtj/stores/store.util'
import PageRoutes from 'todistukset-ui/src/vtj/todistukset-page-routes.enum'
import StepRoutes from 'todistukset-ui/src/vtj/todistukset-step-routes.enum'

export const AetRejectTodistusPyyntoDialogContent = observer(
  ({
    dialogItem,
    aetTodistuspyyntoId,
  }: {
    dialogItem: DialogItem
    aetTodistuspyyntoId: number
  }): React.JSX.Element => {
    const navigate = useNavigate()
    const {
      common: { lang },
    } = useStore()
    const submitDecline = useSubmitDeclineAetTodistuspyynto(aetTodistuspyyntoId)

    const handleRejectAetTodistuspyynto = async () => {
      const onSuccess = () => {
        navigate(
          `/${lang}/${PageRoutes.AETTODISTUS_SIGNER}/${aetTodistuspyyntoId}/${StepRoutes.AET_SIGNER_TODISTUSPYYNTO_REJECTED}`
        )
        dialogItem.active?.resolveDialog('aetRejectTodistuspyyntoRejected')
      }

      await submitDecline({ onSuccess })
    }

    return (
      <React.Fragment>
        <ModalContent
          data-test-id={`${dialogItem.id}-dialog-body`}
          style={{ border: 0 }}
        >
          <ModalTitle>
            <LocalizedString stringKey="aetSignerRejectTodistuspyyntoDialogTitle" />
          </ModalTitle>
          <LocalizedParagraphs stringKey="aetSignerRejectTodistuspyyntoDialogDescription_paragraphs" />
        </ModalContent>
        <ModalFooter style={{ border: 0 }}>
          <Button
            data-test-id="aet-reject-todistuspyynto-button"
            onClick={handleRejectAetTodistuspyynto}
          >
            <LocalizedString stringKey="aetRejectTodistuspyyntoButton" />
          </Button>
          <Button
            data-test-id="aet-reject-todistuspyynto-cancel-button"
            variant="secondary"
            onClick={() => {
              dialogItem.active?.resolveDialog(
                'aetRejectTodistuspyyntoCancelled'
              )
            }}
          >
            <LocalizedString stringKey="cancel" />
          </Button>
        </ModalFooter>
      </React.Fragment>
    )
  }
)
